// extracted by mini-css-extract-plugin
export default {"reserveContainer":"reserve-layout_reserveContainer__roYF3","container":"reserve-layout_container__Yfe55","fullContainer":"reserve-layout_fullContainer__gm4zo"};